<template>
  <div>
    <div class="header">
      <div class="topContent">
        <!-- <img class="header-logo" :src="headerLogo" /> -->
        <div class="project-name" type="text"  @click="showProject" v-show="topbarButtonShow">工作台</div>
        <div class="project-name" type="text"  @click="showHistoryProject" v-show="topbarButtonShow">历史项目</div>
        <div class="right-buttons" v-show="topbarButtonShow">
          <searchButton class="search-button" @searchAction="searchAction"> </searchButton>
          <!-- <el-badge is-dot class="message-button" :hidden="badgeHidden">
            <i class="el-icon-bell" @click="messagecenter"></i>
          </el-badge> -->
          <el-dropdown class="user-info" trigger="click" @command="handleCommand" @visible-change="dropdownclick">
            <span class="el-dropdown-link">
              <el-button type="text">{{user_name}}</el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" class="main" :style="{'min-height':min_height+'px'}"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" class="main" :style="{'min-height':min_height+'px'}"></router-view>
  </div>
</template>
<style lang="scss" scoped>
.header {
  position: fixed;
  background-color: #001529;
  z-index: 99;
  width: 100%;
  height: 60px;
  .topContent {
    display: flex;
    background-color: #001529;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    width: 1200px;
    z-index: 999;
    align-items: center;
    .header-logo {
      width: 100px;
      height: 35px;
    }
    .project-name {
      cursor: pointer;
      text-align: center;
      line-height: 60px;
      margin-left: 20px;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
      background-color: #001529;
      height: 60px;
      width: 68px;
    }
    .project-name:hover {
      color: #3b85f5;
      background-color: #121212;
    }
    .right-buttons {
      margin-right: 0px;
      align-items: center;
      margin-left: auto;
      display: flex;
      .search-button {
        margin-right: 30px;
      }
      .message-button {
        margin-right: 40px;
        color: #ffffff;
      }
      .user-info {
        margin-right: 0px;
        color: #ffffff;
      }
    }
  }
}

.main {
  overflow: hidden;
  background-color: #f0f2f5;
  width: 100%;
  height: 100%;
  padding-top: 60px;
  margin-bottom: 0px;
}
</style>
<style>
.el-badge__content {
  border: 0px solid #fff;
}
</style>
<script>
import config from "@/js/utils/config";
import eventBus from "@/js/utils/eventBus";
import SearchButton from "@/js/components/searchButton";
import $ from "jquery";
let Base64 = require("js-base64").Base64;
export default {
  name: "Main",
  components: {
    searchButton: SearchButton
  },

  data() {
    return {
      min_height: window.innerHeight - 60,
      topbarButtonShow: false,
      badgeHidden: true,
      user_name: "",
      headerLogo: require("@/js/components/header/images/logo.png")
    };
  },

  mounted() {
    var that = this;
    //this.autoSetScale() // 进页面先执行一次页面高度和宽度计算然后赋值
    window.addEventListener(
      "resize",
      () => {
        this.min_height = window.innerHeight - 60;
        //this.autoSetScale()
      },
      false
    );
    // eventBus.$on("updatenotibadge", result => {
    //   console.log(result);
    //   that.getUnReadDoneMessages();
    // });
    eventBus.$on("logout", result => {
      this.logout();
    });

    let hash = window.location.hash;
    let query = hash.split("?")[1];
    let userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {

      this.user_name = userinfo.userName;

      if (this.user_name) {
        this.getClientId();
        // this.getUnReadDoneMessages();
      }
    }
    let queryObject = {};
    if (query) {
      let querys = query.split("&");
      querys.forEach(element => {
        let keys = element.split("=");
        if (keys[0] == "real_name") {
          queryObject[keys[0]] = decodeURI(keys[1]);
        } else {
          queryObject[keys[0]] = keys[1];
        }
      });
      // 将用户名二次解码
      let userName = decodeURIComponent(decodeURIComponent(queryObject["user_name"]));
      let role = queryObject["role"];
      let user_id = queryObject["user_id"];
      if (userName && role && user_id) {
        //设置导航栏用户名
        this.user_name = userName;
        let userInfo = {
          userName: userName,
          role: role,
          userId: user_id
        };
        localStorage.setItem("userinfo", JSON.stringify(userInfo));
        eventBus.$emit("loadFilters");
        localStorage.removeItem("createProject_ProjectId");
        localStorage.removeItem("createProject_OperationType");
        localStorage.removeItem("createConfigScene");
        localStorage.removeItem("projectinfoStack");
        //清空本地所有缓存的数据
      }
    }
    this.route();
  },

  methods: {
    getClientId() {
      this.HttpUtils.get(config.api.client_id, {})
        .then(result => {
          localStorage.setItem("clientId", result.data);
        })
        .then(error => {});
    },

    dropdownclick(val) {
      if (val) {
        let body = {
          event_code: "all_grzx",
          event_name: "个人中心"
        };
        this.CommonSrv.trackEvent(body);
      }
    },
    // 自动缩放屏幕比例
    autoSetScale() {
      let zoom = (window.innerHeight / 1080).toFixed(3);
      this.transformScale = `scale(${zoom})`;
      this.width = `${(window.innerWidth / zoom).toFixed(2)}px`;
    },
    searchAction(query) {
      let body = {
        event_code: "all_ty_ss",
        event_name: "通用-搜索"
      };
      this.CommonSrv.trackEvent(body);
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      if (!userinfo) {
        this.$router.push("/login");
        return;
      }
      let routeName = this.$route.name;
      if (routeName == "searchProject") {
        this.$router.replace({
          path: "/searchProject",
          query: { query: query }
        });
      } else {
        this.$router.push({ path: "/searchProject", query: { query: query } });
      }
    },
    getUnReadDoneMessages() {
      let url = config.api.notification;
      let initParams = { read_done: false, page: 0, per_page: 10 };
      this.HttpUtils.get(url, initParams)
        .then(result => {
          console.log(result);
          this.badgeHidden = !result.data.pagination.total;
        })
        .catch(execption => {
          console.log(execption);
        });
    },

    route() {
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      if (userinfo) {
        this.topbarButtonShow = true;
        let hash = window.location.hash;
        let path = hash.split("?")[0];
        path = path.substring(1, path.length);
        if (path == "/" || path == "/login") {
           this.$router.push("/workerbench");
        } else {
          if (path == "/workerbench") {
             this.$router.push("/workerbench");
          } else {
            let hash = window.location.hash;
            let querystr = hash.split("?")[1];
            let queryObject = {};
            if (querystr) {
              let newqueryStr = String(querystr).slice(0, this.querystr);
              let querys = newqueryStr.split("&");
              querys.forEach(element => {
                let keys = element.split("=");
                queryObject[keys[0]] = keys[1];
              });
            }
            this.$router.push({
              path: path,
              query: queryObject
            });
          }
        }
      } else {
        this.$router.push("/login");
        // let loginUrl =
        //   config.api.login + "?next_url=" + Base64.encode(window.location.href);
        // window.location.href = loginUrl;
      }
    },

    getUrlStr(name, search) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = search.substr(1).match(reg);
      if (r != null) return r[2];
      return null;
    },

    showProject() {
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      if (!userinfo) {
        this.$router.push("/login");
        return;
      }
      if (userinfo.role == 1) {
        //需求方
        let body = {
          event_code: "xqc_xm",
          event_name: "需求侧-回到项目页"
        };
        this.CommonSrv.trackEvent(body);

      } else if (userinfo.role == 2) {
        //项目经理
        let body = {
          event_code: "xmc_xm",
          event_name: "项目侧_回到项目页"
        };
        this.CommonSrv.trackEvent(body);
      }
       this.$router.push("/workerbench");
    },
    showHistoryProject() {
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      if (!userinfo) {
        this.$router.push("/login");
        return;
      }
      this.$router.push("/workerbench/history");
    },

    messagecenter() {
      let body = {
        event_code: "all_ty_xxzx",
        event_name: "通用-消息中心"
      };
      this.CommonSrv.trackEvent(body);
      let userinfo = JSON.parse(localStorage.getItem("userinfo"));
      if (!userinfo) {
        this.$router.push("/login");
        return;
      }
      this.$router.push("/message-center");
    },

    handleCommand(command) {
      console.log(command);
      // this.$message('click on item ' + command);
      //调用退出登录接口
      this.logoutAction();
    },

    setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    },

    logout() {
      localStorage.removeItem("userinfo");
      // let href = window.location.origin;
      // window.location.href = href;
      this.$router.push("/login");
      this.user_name = "";
      this.topbarButtonShow = false;
    },

    logoutAction() {
      let body = {
        event_code: "all_grzx_tcdl",
        event_name: "个人中心-退出登录"
      };
      this.CommonSrv.trackEvent(body);
      let that = this;
      let url = config.api.logout;
      this.HttpUtils.get(url, {})
        .then(result => {
          let clientId = localStorage.getItem("clientId");
          that.deleteCookie(clientId, "/", ".zzcrowd.com");
          console.log(result);
          that.logout();
        })
        .catch(execption => {
          console.log(execption);
        });
    },

    deleteCookie(name, path, domain) {
      // $.cookie("t9sIxnMC4INUOL0VAqh8xSw1afV2iVePbzIdAh8P", null, { path: "/" });
      // console.log($.cookie("the_cookie"));
      // location.href = "https://label-test.zzcrowd.com";
      document.cookie =
        name +
        "=" +
        (path ? ";path=" + path : "") +
        (domain ? ";domain=" + domain : "") +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT";

    }
  }
};
</script>





// WEBPACK FOOTER //
// src/js/modules/main/index.vue